import type React from 'react';

import { FormField, Heading, Label, Paragraph } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { SECURITY_DEPOSIT } from '../../../constants';
import CurrencyInput from '../../Widgets/CurrencyInput';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function RentalProtectionSecurityDeposit({ section, setSectionValues }: Props) {
  function onSecurityDepositChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [SECURITY_DEPOSIT.FIELD_NAME.AMOUNT]: value,
    });
  }

  return (
    <>
      <Heading level={3} textStyle="responsive.heading-sm" css={{ marginBottom: 'layout.tight' }}>
        Is this the security deposit amount in the lease you uploaded?
      </Heading>
      <Paragraph css={{ marginBottom: 'layout.tight' }}>
        <strong>Confirm that the amount shown matches the amount in your lease</strong>
      </Paragraph>
      <Paragraph css={{ marginBottom: 'layout.tight' }}>
        If you want the security deposit amount to be different than the one in the lease, we recommend uploading a new
        lease with the correction.
      </Paragraph>
      <FormField
        required
        label={<Label>Security deposit</Label>}
        control={
          <CurrencyInput
            value={section.getFieldValue(SECURITY_DEPOSIT.FIELD_NAME.AMOUNT)}
            onChange={onSecurityDepositChange}
            onBlur={onSecurityDepositChange}
          />
        }
      />
    </>
  );
}

export default RentalProtectionSecurityDeposit;
